<template>
  <div>
    <div class="row">
      <b-form-group
          :label="`${lodash.upperFirst($t('purchase_orders.ticket_id'))}*`"
          class="mb-3"
          label-cols-md="12"
      >
        <input :value="ticketValueFormatter((model || {}).ticket)" class="form form-control" disabled>
      </b-form-group>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('purchase_orders.send_to_rfq')"
          class="col-md-6"
          vid="send_to_rfq"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="$t('purchase_orders.forms.send_to_rfq_question')"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-checkbox
              v-model="model.send_to_rfq"
              :disabled="true"
              :unchecked-value="false"
              :value="true"
              name="send_to_rfq"
              stacked
          />
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <b-form-group
          :keys="`products-${(model.product || {}).id}`"
          :label="`${lodash.upperFirst($t('products.singular'))}`"
          class="mb-3 col-md-6"
          label-cols-md="12"
      >
        <input :value="productLabel(model)" class="form form-control" disabled>
      </b-form-group>
      <b-form-group
          :label="`${lodash.upperFirst($t('margin_per_kg'))}`"
          class="mb-3 col-md-6"
          label-cols-md="12"
      >
        <numeral-input
            id="service_fee"
            v-model.number="model.service_fee"
            disabled=""
            format="$ 0,0.[00]"
            lazy-formatter
            name="service_fee"
        />
      </b-form-group>
    </div>
    <div class="row">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('purchase_orders.partner'))"
          class="col-md-4"
          rules="required"
          vid="customer_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('purchase_orders.partner')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <input :value="customerValueFormatter((model || {}).customer)" class="form form-control" disabled>
        </b-form-group>
      </validation-provider>
      <validation-provider v-slot="{ validated, errors }" :name="$t('purchase_orders.farmer_id')" class="col-md-4"
                           vid="farmer_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('purchase_orders.from_farmer'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <input :value="farmerLabel((model || {}).farmer)" class="form form-control" disabled>
        </b-form-group>
      </validation-provider>
      <validation-provider v-slot="{ validated, errors }" :name="$t('purchase_orders.farm_id')" class="col-md-4"
                           vid="farm_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase('nama tambak')"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <input :value="farmValueFormatter((model || {}).farm)" class="form form-control" disabled>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('purchase_orders.hatchery_id'))"
          class="col-md-6"
          vid="hatchery_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('purchase_orders.hatchery'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <manufacture-select-ajax
              :key="`${_uid}-hatchery`"
              ref="hatchery_multiselect"
              v-model.number="model.hatchery_id"
              :params="{ type: 'seed', is_active: 1, or_where_id__in: model.hatchery_id }"
              name="hatchery_id"
          >
          </manufacture-select-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('purchase_orders.feed_product_id'))"
          class="col-md-6" rules="max:255"
          vid="feed_product_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('feeds.plural'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-feed-products`"
              ref="feed_product_multiselect"
              v-model="model.feed_product_ids"
              :custom-label="({name}) => name"
              :multiple="true"
              :params="feedProductParams"
              :url="`/v1/feed_products`"
              name="feed_product_ids"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider v-if="isDownPaymentInvoice" v-slot="{ validated, errors }
            " :name="lodash.upperFirst($t('purchase_orders.estimated_ordered_at'))"
                           :rules="estimatedHarvestRules"
                           class="col-md-4"
                           vid="estimated_harvest_date">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('purchase_orders.estimated_ordered_at')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <date-picker
              v-model="model.estimated_harvest_date"
              :state="errors[0] ? false : (validated ? true : null)"
              format="DD MMMM YYYY"
              name="estimated_harvest_date"
              required
              type="date"
              @input="emitModel"
          >
          </date-picker>
        </b-form-group>
      </validation-provider>
      <validation-provider v-else v-slot="{ validated, errors }
          " :name="lodash.upperFirst($t('purchase_orders.ordered_at'))"
                           :rules="`required|before_or_equal:${this.$moment().format('YYYY-MM-DD')}`"
                           class="col-md-4"
                           vid="ordered_at">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('purchase_orders.ordered_at')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <date-picker
              v-model="model.ordered_at"
              disabled
              format="DD MMMM YYYY"
              name="ordered_at"
              required
              type="date"
          >
          </date-picker>
        </b-form-group>
      </validation-provider>
      <template v-if="model.type === 'hybrid'">
        <validation-provider v-slot="{ validated, errors }"
                             :name="lodash.upperFirst($t('purchase_orders.top'))"
                             class="col-md-4" rules="required|min_value:0"
                             vid="top">
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('purchase_orders.top'))}*`"
              :state="errors[0] ? false : (validated ? true : null)"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-input-group :append="$t('units.days')">
              <b-form-input
                  id="top"
                  v-model.number="model.duration"
                  :placeholder="lodash.upperFirst($t('purchase_orders.top'))"
                  :state="errors[0] ? false : (validated ? true : null)"
                  name="top"
                  style="text-align: right"
                  type="number"
              />
            </b-input-group>
          </b-form-group>
        </validation-provider>
        <div class="col-md-4">

          <b-form-group
              :label="`${lodash.upperFirst($t('due_date'))}*`"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-form-input
                :value="dueDate"
                readonly
            />
          </b-form-group>
        </div>
      </template>
    </div>

    <b-form-group
        v-if="model.invoice_documents.length > 0"
        :label="$t('purchase_orders.file')"
        class="row mb-3"
        label-cols-md="12"
    >
      <div key="invoice_document" class="row g-2 mt-2">
        <validation-provider
            :key="model.invoice_document.preview"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_payments.invoice_document'))"
            vid="invoice_document"
        >
          <div class="row">
            <!-- {{ model.invoice_documents }} -->
            <template
                v-for="(file, index) in model.invoice_documents"
            >
              <preview-image-pdf
                  v-if="file._action !== 'delete'"
                  :key="index"
                  :format="file.extension"
                  :preview="file.preview"
                  class="col-md-3 mb-2"
                  image-style="height: 200px; width: 100%; object-fit: contain;"
                  @delete="removeFile(file)"
              />
            </template>
          </div>
        </validation-provider>
      </div>
    </b-form-group>
    <b-form-group
        v-if="model.down_payment_documents.length > 0"
        :label="$t('purchase_orders.down_payment_document')"
        class="row mb-3"
        label-cols-md="12"
    >
      <div key="down_payment_document" class="row g-2 mt-2">
        <validation-provider
            :key="model.down_payment_document.preview"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_payments.down_payment_document'))"
            vid="down_payment_document"
        >
          <div class="row">
            <!-- {{ model.down_payment_documents }} -->
            <template
                v-for="(file, index) in model.down_payment_documents"
            >
              <preview-image-pdf
                  v-if="file._action !== 'delete'"
                  :key="index"
                  :format="file.extension"
                  :preview="file.preview"
                  class="col-md-3 mb-2"
                  image-style="height: 200px; width: 100%; object-fit: contain;"
                  @delete="removeFile(file)"
              />
            </template>
          </div>
        </validation-provider>
      </div>
    </b-form-group>

    <validation-provider v-if="isDownPaymentInvoice" v-slot="{ validated, errors }"
                         :name="lodash.startCase($t('purchase_orders.down_payment'))" rules="required|gt:0"
                         vid="down_payment">
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="`${lodash.startCase($t('purchase_orders.down_payment'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          class="row mb-3"
          label-cols-md="12"
          style="font-style: italic;"
      >
        <numeral-input
            id="down_payment"
            v-model.number="model.down_payment"
            :disabled="downPaymentDisabledRules"
            :placeholder="'Rp'"
            :state="errors[0] ? false : (validated ? true : null)"
            format="$ 0,0.[00]"
            lazy-formatter
            name="down_payment"
            @blur="updateLocalStorage"
            @change="$emit('input', model)"
        />
      </b-form-group>
    </validation-provider>
    <hr v-if="model.ticket.customer_type === 'lcs'">
    <div v-if="model.type !== 'down_payment'">
      <b-form-group
          :label="lodash.startCase($t('purchase_orders.purchase_item'))"
          class="mb-3"
          label-class="custom-label-form-group"
          label-cols-sm="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.purchase_item')) }}</div>
          </div>
        </template>
        <template v-for="(purchase_item, key) in model.purchase_items">
          <b-form-group
              v-bind:key="key"
              :label="`${key + 1}`"
              class="row mb-3"
              label-cols="1"
          >
            <div class="row">
              <b-form-group :label="`${lodash.startCase($t('purchase_orders.quality'))}*`"
                            class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2">
                <input :value="qualityValueFormatter(purchase_item.quality)" class="form form-control" disabled/>
              </b-form-group>
              <validation-provider
                  v-slot="{ validated, errors }"
                  :name="lodash.upperFirst($t('purchase_orders.doc'))"
                  :vid="`purchase_items.${key}.doc`"
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
                  rules="gt:0|integer"
              >
                <b-form-group
                    :invalid-feedback="errors[0]"
                    :label="`${lodash.upperFirst($t('purchase_orders.doc'))} (${$t('Days')})`"
                    :state="errors[0] ? false : (validated ? true : null)"
                >
                  <b-input-group>
                    <numeral-input
                        id="doc"
                        v-model="purchase_item['doc']"
                        :name="`purchase_items[${key}][doc]`"
                        :placeholder="`${lodash.upperFirst($t('purchase_orders.doc'))} (${$t('Days')})`"
                        :state="errors[0] ? false : (validated ? true : null)"
                        style="text-align: right"
                    />
                  </b-input-group>
                </b-form-group>
              </validation-provider>
              <b-form-group
                  :label="`${lodash.upperFirst($t('purchase_orders.biomassa'))} (${lodash.upperFirst($t('units.kg'))})*`"
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
              >
                <b-input-group>
                  <numeral-input
                      id="quantity"
                      v-model="purchase_item['quantity']"
                      :name="`purchase_items[${key}][quantity]`"
                      :placeholder="`${lodash.upperFirst($t('purchase_orders.biomassa'))} (${lodash.upperFirst($t('units.kg'))})`"
                      disabled=""
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group
                  :label="`${lodash.upperFirst($t('purchase_orders.size'))}*`"
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
              >
                <b-input-group>
                  <numeral-input
                      id="size"
                      v-model="purchase_item['size']"
                      :name="`purchase_items[${key}][size]`"
                      :placeholder="lodash.upperFirst($t('purchase_orders.size'))"
                      disabled
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group
                  :label="`${lodash.upperFirst($t('purchase_orders.unit_price'))}*`"
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
              >
                <b-input-group>
                  <numeral-input
                      id="unit_price"
                      v-model="purchase_item['unit_price']"
                      :name="`purchase_items[${key}][unit_price]`"
                      :placeholder="lodash.upperFirst($t('purchase_orders.unit_price'))"
                      disabled
                      format="$ 0,0.[00]"
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group
                  :label="`${lodash.upperFirst($t('purchase_orders.total_price'))}*`"
                  class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
              >
                <b-input-group>
                  <numeral-input
                      id="total_price"
                      v-model="purchase_item['total_price']"
                      :name="`purchase_items[${key}][total_price]`"
                      :placeholder="lodash.upperFirst($t('purchase_orders.total_price'))"
                      disabled
                      format="$ 0,0.[00]"
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
            </div>
          </b-form-group>
        </template>
      </b-form-group>
      <hr>
    </div>
    <b-form-group
        :label="lodash.startCase($t('purchase_orders.additional_fee'))"
        class="row mb-3"
        label-cols-md="12"
    >
      <template #label>
        <div class="d-flex justify-content-between section-label">
          <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.additional_fee')) }}</div>
        </div>
      </template>
      <div v-if="model.additional_fees.length">
        <template v-for="(additional_item, key) in model.additional_fees">
          <template v-if="additional_item._action !== 'delete'">
            <div :key="`additional_fees.key.${key}`" :class="`row g-2 ${key === 0 ? '' : 'mt-2'}`">
              <validation-provider v-slot="{ validated, errors }"
                                   :name="lodash.upperFirst(`${$t('additional_fees.total')} ${key+1}`)"
                                   :vid="`additional_fees.${key}.total`"
                                   class="col-md-3" rules="required|gt:0"
              >
                <b-form-group
                    :invalid-feedback="errors[0]"
                    :label="`${lodash.upperFirst(additional_item['name'])}`"
                    :state="errors[0] ? false : (validated ? true : null)"
                >
                  <numeral-input
                      :id="`${_uid}-value`"
                      v-model="additional_item['total']"
                      :name="`additional_fees[${key}][total]`"
                      :placeholder="lodash.upperFirst('Ex: 1000')"
                      :state="errors[0] ? false : (validated ? true : null)"
                      format="$ 0,0.[00]"
                      lazy-formatter
                      required
                      style="text-align: right"
                      @blur="onChangeAdditionalFeeTotal"
                      disabled
                  />
                </b-form-group>
              </validation-provider>
            </div>
          </template>
        </template>
      </div>
      <div v-else class="text-center empty-state">
        Belum ada biaya tambahan
      </div>
    </b-form-group>
    <hr>
    <b-form-group
        :label="lodash.startCase($t('purchase_orders.discount'))"
        class="row mb-3"
        label-cols-md="12"
    >
      <template #label>
        <div class="d-flex justify-content-between section-label">
          <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.discount')) }}</div>
        </div>
      </template>
      <div v-if="model.discounts.length">
        <template v-for="(discount, key) in model.discounts">
          <div :key="`discounts.key.${key}`" :class="`row g-2 ${key === 0 ? '' : 'mt-2'}`">
            <validation-provider v-slot="{ validated, errors }"
                                 :name="lodash.upperFirst(`${$t('additional_fees.total')} ${key+1}`)"
                                 :vid="`discounts.${key}.total`"
                                 class="col-md-3" rules="required|gt:0"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.upperFirst(discount['name'])}`"
                  :state="errors[0] ? false : (validated ? true : null)"
              >
                <numeral-input
                    :id="`${_uid}-value`"
                    v-model="discount['total']"
                    :name="`discounts[${key}][total]`"
                    :placeholder="lodash.upperFirst('Ex: 1000')"
                    :state="errors[0] ? false : (validated ? true : null)"
                    format="$ 0,0.[00]"
                    lazy-formatter
                    required
                    style="text-align: right"
                    @blur="onChangeDiscountTotal"
                    disabled
                />
              </b-form-group>
            </validation-provider>
          </div>
        </template>
      </div>
      <div v-else class="text-center empty-state">
        Belum ada potongan biaya
      </div>
    </b-form-group>
    <hr>
    <b-form-group
        :label="lodash.startCase($t('purchase_orders.total_biomassa'))"
        class="row mb-3"
        label-cols-md="12"
    >
      <b-input-group :append="$t('units.kg')">
        <numeral-input
            :disabled="true"
            :value="purchaseOrderTotalTonase"
            name="total"
            style="text-align: right"
        />
      </b-input-group>
    </b-form-group>
    <b-form-group
        :label="lodash.startCase($t('purchase_orders.total_price'))"
        class="row mb-3"
        label-cols-md="12"
    >
      <b-input-group>
        <numeral-input
            id="total"
            v-model.number="model.total"
            :disabled="true"
            :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
            format="$ 0,0.[00]"
            name="total"
            style="text-align: right"
        />
      </b-input-group>
    </b-form-group>
    <hr>
    <template v-if="ticketCustomerType === 'brs'">
      <b-form-group
          :label="lodash.startCase($t('operational_costs.singular'))"
          class="row mb-3"
          label-cols-md="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary">{{ lodash.upperCase($t('operational_costs.singular')) }}</div>
          </div>
        </template>
        <div class="row px-2">
          <div class="col-md-4 row g-2 mb-2">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst($t('shipping_costs.singular'))"
                class="col-md-12"
                rules="min_value:0" vid="shipping_cost"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('glazing cost'))"
                  :state="errors[0] ? false : (validated ? true : null)"
              >
                <numeral-input
                    id="total"
                    v-model.number="model.ice_cost"
                    :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    disabled
                    format="$ 0,0.[00]"
                    name="total"
                    style="text-align: right"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-md-4 row g-2 mb-2">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst($t('shipping_costs.singular'))"
                class="col-md-12"
                rules="min_value:0" vid="shipping_cost"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('shipping cost'))"
                  :state="errors[0] ? false : (validated ? true : null)"
              >
                <numeral-input
                    id="total"
                    v-model.number="model.shipping_cost"
                    :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    disabled
                    format="$ 0,0.[00]"
                    name="total"
                    style="text-align: right"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-md-4 row g-2 mb-2">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst($t('shipping_costs.singular'))"
                class="col-md-12"
                rules="min_value:0" vid="shipping_cost"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('labour cost'))"
                  :state="errors[0] ? false : (validated ? true : null)"
              >
                <numeral-input
                    id="total"
                    v-model.number="model.labour_cost"
                    :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    disabled
                    format="$ 0,0.[00]"
                    name="total"
                    style="text-align: right"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <template v-for="(operational_cost, key) in model.other_operational_costs">
            <div :key="`other-operational-cost-${key}`" class="row col-md-4 g-2">
              <div class="row g-2 mb-2">
                <validation-provider
                    v-slot="{ validated, errors }"
                    :name="lodash.upperFirst($t('purchase_orders.total'))"
                    :vid="`other_operational_costs.${key}.total`"
                    class="col-md-12 mt-2"
                    rules="gt:0|integer"
                >
                  <b-form-group
                      :invalid-feedback="errors[0]"
                      :label="`${lodash.upperFirst(operational_cost['name'])}`"
                      :state="errors[0] ? false : (validated ? true : null)"
                  >
                    <b-input-group>
                      <numeral-input
                          id="total"
                          v-model="operational_cost['total']"
                          :name="`other_operational_costs[${key}][total]`"
                          :placeholder="`${lodash.upperFirst($t('purchase_orders.total'))}`"
                          :state="errors[0] ? false : (validated ? true : null)"
                          format="$ 0,0.[00]"
                          style="text-align: right"
                          @blur="updateLocalStorage"
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </div>
              <!-- <div :key="`operational-cost-option-${key}`" class="row g-2">
                <div class="col-sm delete-item">
                  <div class="float-end">
                    <b-button
                        v-if="(model.other_operational_costs || []).length > 0"
                        size="sm"
                        tag="span"
                        variant="link"
                        class="text-danger"
                        style="margin-right: 10px;"
                        @click="removeOtherOperationalCost(key)"
                    >
                      {{ $t('Delete') }}
                    </b-button>
                    <b-button
                        v-if="key === (model.other_operational_costs || []).length - 1"
                        size="sm"
                        tag="span"
                        variant="link"
                        @click="addOtherOperationalCost"
                    >
                      {{ $t('Add new {something}', { something: '' }) }}
                    </b-button>
                  </div>
                </div>
              </div> -->
            </div>
          </template>
        </div>
        <!-- <div class="float-end clearfix" v-if="(model.other_operational_costs || []).length === 0">
          <b-button size="sm" tag="span" variant="link" @click="addOtherOperationalCost">{{ $t('Add new {something}', { something: '' }) }}</b-button>
        </div> -->
      </b-form-group>
      <b-form-group
          :label="lodash.startCase($t('purchase_orders.operational_cost_file'))"
          class="row mb-3"
          content-cols="12"
          content-cols-md="10"
          label-cols-md="12"
      >
        <div key="operational_cost_document" class="row g-2">
          <validation-provider
              :key="(model.operational_cost_document || {}).preview"
              v-slot="{ validated, errors }"
              :name="lodash.upperFirst($t('purchase_payments.operational_cost_document'))"
              vid="operational_cost_document"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : (validated ? true : null)"
            >
              <div class="row">
                <preview-image-pdf
                    :format="(model.operational_cost_document || {}).extension"
                    :preview="(model.operational_cost_document || {}).preview"
                    class="col-md-6 mb-2"
                    image-style="height: 200px; width: 100%; object-fit: contain;"
                    @delete="onDeleteFile('operational_cost_document')"
                />
              </div>
            </b-form-group>
          </validation-provider>
        </div>
      </b-form-group>
      <b-form-group
          :label="lodash.upperFirst($t('purchase_orders.sub_total'))"
          class="row"
          label-cols="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.sub_total')) }}</div>
          </div>
        </template>
        <input :value="$numeral(purchaseOrderSubTotal).format('$ 0,0.[00]')" class="form form-control"
               disabled style="text-align: right"/>
      </b-form-group>
      <hr>
    </template>
    <template v-if="model.type === 'harvest'">
      <b-form-group
          :label="lodash.startCase($t('operational_costs.singular'))"
          class="row mb-3"
          label-cols-md="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary">
              {{ lodash.upperCase($t("operational_costs.singular")) }}
            </div>
          </div>
        </template>
        <div class="row px-2">
          <div class="col-md-4 row g-2 mb-2">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('purchase_orders.mark_up'))"
                class="col-md-12"
                rules="min_value:0"
                vid="mark_up"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('purchase_orders.mark_up'))"
                  :state="errors[0] ? false : (validated ? true : null)"
              >
                <b-input-group
                    append="/kg"
                >
                  <numeral-input
                      id="mark_up"
                      v-model.number="model.mark_up"
                      :placeholder="lodash.upperFirst($t('purchase_orders.mark_up'))"
                      :state="errors[0] ? false : (validated ? true : null)"
                      format="$ 0,0.[00]"
                      name="mark_up"
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-6 row mt-3">
            <b-table-simple borderless class="w-100">
              <b-thead>
                <b-tr class="bg-slate-100 text-neutral-600">
                  <b-th>Glazing/Ice</b-th>
                  <b-th>Shipping</b-th>
                  <b-th>Labour</b-th>
                  <b-th>Total Biaya Operasional</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>{{ $numeral(costItem.ice).format("$ 0,0.[00]") }}</b-td>
                  <b-td>{{ $numeral(costItem.delivery).format("$ 0,0.[00]") }}</b-td>
                  <b-td>{{ $numeral(costItem.labour).format("$ 0,0.[00]") }}</b-td>
                  <b-td>{{ $numeral(model.total_operational_cost).format("$ 0,0.[00]") }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-form-group>
    </template>
    <validation-provider v-slot="{ validated, errors }" :name="lodash.upperFirst($t('models.description'))"
                         rules="max:255"
                         vid="description">
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('models.description'))"
          :state="errors[0] ? false : (validated ? true : null)"
          class="row mb-3"
      >
        <editor
            v-if="$parent.$parent.$options.name !== 'BModal'"
            ref="editor"
            v-model="model.description"
            :init="editorInit"
            class="form-control"
            inline
            plugins="lists link image paste help wordcount"
            toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
            @input="emitModel"
        />
        <b-form-textarea v-else v-model="model.description"/>
      </b-form-group>
    </validation-provider>
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/datepicker'
import Editor from '@tinymce/tinymce-vue'
import NumeralInput from '@/components/inputs/numeral'
import ManufactureSelectAjax from "@/components/inputs/manufacture-select-ajax.vue";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax.vue";

export default {
  name: 'after-payment',
  props: {
    value: {
      type: Object, default: () => {
      },
    },
  },
  components: {
    MultiselectAjax,
    ManufactureSelectAjax,
    DatePicker,
    Editor,
    NumeralInput,
  },
  data() {
    return {
      editorInit: {
        height: 512,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: this.editorFilePickerCallback,
        mobile: {
          inline: true
        }
      },
      model: {...this.value}
    }
  },
  created() {
    if (this.model.type === 'harvest') {
      this.model.total_operational_cost = (this.model.mark_up ?? 0) * this.purchaseOrderTotalTonase
    }
  },
  computed: {
    feedProductParams() {
      return {
        is_active: 1,
        sort: 'name,asc',
        or_where_id__in: this.model.feed_products.map(({id}) => id).join(',')
      }
    },
    dueDate() {
      let {ordered_at, duration, unit_duration} = this.model
      if (!ordered_at) return '-'
      return this.$moment(ordered_at, 'YYYY-MM-DD').add(duration ?? 0, unit_duration ?? 'days').format('D MMMM YYYY')
    },
    isDownPaymentInvoice() {
      return this.model.type === 'down_payment'
    },
    costItem() {
      const totalOpCost = (this.model.mark_up ?? 0) * this.purchaseOrderTotalTonase
      return {
        ice: totalOpCost * 0.1508,
        labour: totalOpCost * 0.3823,
        delivery: totalOpCost * 0.4669,
      }
    },
    purchaseOrderSubTotal() {
      let iceCost = this.model.ice_cost || 0
      let shippingCost = this.model.shipping_cost || 0
      let labourCost = this.model.labour_cost || 0
      let operationalCostTotal = iceCost + shippingCost + labourCost + this.model.other_operational_costs.reduce((carry, {total}) => carry + (total || 0), 0)
      return this.purchaseOrderTotalPrice + operationalCostTotal
    },
    purchaseOrderTotalPrice() {
      let purchaseItemTotal = this.model.purchase_items.filter(purchaseItem => purchaseItem._action !== 'delete').reduce((total, v) => total + v.quantity * v.unit_price, 0)
      let additionalFeeTotal = this.model.additional_fees.filter(additionalFee => additionalFee._action !== 'delete').reduce((total, v) => total + (v.total || 0), 0)
      let discounts = this.model.discounts.filter(discount => discount._action !== 'delete').reduce((total, v) => total + (v.total || 0), 0)
      return purchaseItemTotal + additionalFeeTotal - discounts;
    },
    purchaseOrderTotalTonase() {
      return (this.model.purchase_items.filter(purchaseItem => purchaseItem._action !== 'delete').reduce((total, v) => total + (v.quantity || 0), 0))
    },
    ticketCustomerType() {
      return this.model?.ticket?.customer_type?.toLowerCase()
    }
  },
  watch: {
    'model.mark_up'() {
      this.model.total_operational_cost = (this.model.mark_up ?? 0) * this.purchaseOrderTotalTonase
    },
    purchaseOrderTotalTonase() {
      this.model.total_operational_cost = (this.model.mark_up ?? 0) * this.purchaseOrderTotalTonase
    },
    model: {
      deep: true,
      handler: function (val) {
        this.$emit('input', this.lodash.cloneDeep(val))
      }
    }
  },
  methods: {
    farmerLabel(value) {
      if (!value) return '-'
      const {code, name, region_full_name, phone_number} = value
      let additional = code
      if (region_full_name) additional = `${additional} - ${region_full_name}`
      if (phone_number) additional = `${additional} - ${phone_number}`

      return `${name} (${additional})`
    },
    customerValueFormatter(customer) {
      if (this.lodash.isEmpty(customer)) return '-'
      return customer?.name
    },
    farmValueFormatter(farm) {
      if (this.lodash.isEmpty(farm)) return '-'
      return [farm.name, farm.region_full_name].join(' - ')
    },
    qualityValueFormatter(quality) {
      if (!quality) return '-'
      return this.lodash.startCase(this.$t(`purchase_items.qualities.${quality}`))
    },
    productLabel(purchaseOrder) {
      if (this.lodash.isEmpty(purchaseOrder?.product)) return '-'
      return purchaseOrder.sub_product_name === '-' ? purchaseOrder.product.name : purchaseOrder.sub_product_name
    },
    ticketValueFormatter(ticket) {
      if (this.lodash.isEmpty(ticket)) return '-'
      return `${ticket.id}: ${this.$t(`tickets.customer_types.${ticket.customer_type}`)}`
    },
    emitModel() {
      this.$emit('input', this.lodash.cloneDeep(this.model))
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  color: #ACAEBD;
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084F3;
}
</style>